const AboutUs = () => {
  return (
    <div className="min-h-screen container mx-auto my-10">
      <p className="text-center text-2xl">
        আমাদের সম্পর্কে জানতে আগ্রহী হওয়ার জন্য ধন্যবাদ!
      </p>
      <div className="my-5 w-4/5 mx-auto">
        <div
          tabIndex="0"
          className="collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">আমরা কারা?</div>
          <div className="collapse-content">
            <p> আমরা আহলুস সুন্নাহ আল জামাতের অন্তর্ভুক্ত। </p>
            <p> আমরা রাফেজি বা কাদিয়ানী নই। </p>
            <p> আমরা সালাফী, আমরা প্রচলিত কোন মাজহাবের অন্ধ অনুসরণকারী নই। </p>
          </div>
        </div>
        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">
            এই প্রতিষ্ঠানটি কাদের দ্বারা পরিচালিত?
          </div>
          <div className="collapse-content">
            <p>
              এই প্রতিষ্ঠানটি বিশ্বস্ত ও অভিজ্ঞ সালাফি আলেমদের দ্বারা পরিচালিত,
              যারা সৌদি আরবের বিভিন্ন দাওয়াহ সেন্টারে দীর্ঘদিন যাবত দাঈ হিসেবে
              সফলতার সাথে দায়িত্ব পালন করে আসছেন।
            </p>
          </div>
        </div>
        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">
            আমাদের আক্বীদাহ ও মানহাজ কি?
          </div>
          <div className="collapse-content">
            <p>আমাদের আক্বীদাহ কোরআন ও সহীহ সুন্নাহর সাথে বাঁধা । </p>
            <p>
              আমাদের মানহাজ, সাহাবায়ে কেরামের বুঝ অনুযায়ী কোরআন ও সহীহ সুন্নাহ
              বুঝা এবং মেনে চলা; নিজেদের মন মত নয়।
            </p>

            <p>
              আমরা তাওহিদ শিরক সুন্নাহ বিদাআহ এবং বিশুদ্ধ আকীদাকে গুরুত্বের চোখে
              দেখি।
            </p>
          </div>
        </div>
        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">সালাফী কারা?</div>
          <div className="collapse-content">
            <p>
              সালাফী তাদেরকে বলে, যারা কোরআন ও সহীহ সুন্নাহ অনুসরণ করে-
              সাহাবায়ে কেরামের বুঝ অনুযায়ী। এই মানহাজ এর উপর যে সকল আলেম-ওলামা
              ছিলেন এবং আছেন তাদেরকে আমরা শ্রদ্ধা করি, কিন্তু কাউকে ভুলের
              উর্ধ্বে মনে করি না, কিংবা একক ভাবে কারো অন্ধ আনুগত্য করি না, কাউকে
              নবী-রাসূলের ওপরে স্থান দেই না। তবে সকল মুসলিমদের জন্য আমরা দোয়া
              করি।
            </p>
          </div>
        </div>

        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">
            প্রচলিত চার মাজহাব সম্পর্কে আমাদের অবস্থান কি?
          </div>
          <div className="collapse-content">
            <p>
              আমরা হানাফী শাফি মালেকি বা হাম্বলী নই, কিন্তু এদের সকলকে আমরা
              মুসলিম মনে করি এবং হকের উপরে আছে বলে মনে করি তবে ভুলের উর্ধে মনে
              করি না। এদের মধ্যে কেউ বিশেষ কোন মাসআলায় ভুল করলে সেটাকে আমরা ভুল
              বলি।
            </p>
          </div>
        </div>
        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">
            বাংলাদেশ ও ভারতে আমরা কিভাবে পরিচিত?
          </div>
          <div className="collapse-content">
            <p>
              আমরা আহলে হাদিস নামে পরিচিত। কিন্তু আহলে হাদিস নাম গ্রহণ করাটা
              আবশ্যক মনে করি না। তাই আমরা কখনো কাউকে আহলে হাদিস হওয়ার জন্য
              আহ্বান করি না।
            </p>
            <p>
              আমরা কোরআন ও সহীহ সুন্নাহ, সাহাবায়ে কেরামের বুঝ অনুযায়ী ইসলামকে
              বুঝতে এবং আমল করতে দাওয়াত দেই এবং উদ্বুদ্ধ করি। এই নীতিতে আমরা
              পড়াশোনা করি, এই নীতিতে আমরা দাওয়াত দেই, এবং এই নীতিতে আমরা আমল
              করি।
            </p>
          </div>
        </div>

        <div
          tabIndex="0"
          className="my-2 collapse collapse-plus border border-base-300 bg-base-100 rounded-box"
        >
          <div className="collapse-title text-xl font-medium">
            এই কোর্সগুলো কি যে কেউ করতে পারবে?
          </div>
          <div className="collapse-content">
            <p>
              জি, এই কোর্সগুলো বাংলাভাষী যে কেউ করতে পারবে। যে কোন শ্রেণিপেশার
              মানুষ আমাদের কোর্স থেকে উপকৃত হতে পারে।
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
